module.exports = __webpack_public_path__ + "static/media/IMG_4388a.a1d4a91d.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/roraima/IMG_4388a.JPG
// module id = 121
// module chunks = 0